import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectStudent } from "../../../features/student/studentSlice";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { FaArrowRight } from "react-icons/fa";

interface RenderStudentListProps {
  data: any;
  data2: any;
  mobilescreen: boolean;
}

const RenderStudentList = ({
  data,
  data2,
  mobilescreen,
}: RenderStudentListProps) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <div className="space-y-2 w-full">
      {data &&
        data.map((item: any, index: number) => {
          const classRoomName =
            data2 &&
            data2.find((classItem: any) => classItem.id === item.classroom_id);

          return (
            <div
              key={index}
              className={`bg-white border border-gray-100 hover:border-gray-200 hover:shadow-xs rounded-2xl p-3 md:p-4 transition-all duration-150 items-center text-left text-[14px] font-semibold text-slate-600 ${
                mobilescreen
                  ? "flex flex-col gap-4 text-center p-5 border shadow-md my-3 rounded-[25px]"
                  : "grid grid-cols-12 w-full px-6"
              }`}
            >
              {/* Pupil Avatar Frame Block */}
              <div
                className={`${mobilescreen ? "w-full flex justify-center" : "col-span-2 pl-2"}`}
              >
                <div className="h-12 w-12 rounded-full overflow-hidden border-2 border-[#0096D1]/30 bg-slate-50 shadow-inner flex items-center justify-center">
                  <LazyLoadImage
                    style={{
                      height: "100%",
                      width: "100%",
                      objectFit: "cover",
                    }}
                    src={item?.profile_picture?.props?.src}
                    effect="blur"
                    wrapperProps={{
                      style: {
                        transitionDelay: "0.2s",
                        width: "100%",
                        height: "100%",
                      },
                    }}
                    alt="pupil profile picture"
                  />
                </div>
              </div>

              {/* Student Full Name Label Section */}
              <div
                className={`text-[#012063] font-black truncate capitalize ${mobilescreen ? "w-full text-base" : "col-span-4"}`}
              >
                {`${item?.firstname || ""} ${item?.surname || ""} ${item?.othername || ""}`}
              </div>

              {/* Date of Birth Label */}
              <div
                className={`text-center font-mono text-xs text-slate-500 ${mobilescreen ? "w-full" : "col-span-2"}`}
              >
                {mobilescreen && (
                  <span className="text-[10px] text-slate-400 block uppercase font-sans font-bold">
                    DOB:
                  </span>
                )}
                {item.date_of_birth || (
                  <span className="text-slate-300">—</span>
                )}
              </div>

              {/* Classroom Mini Pill Allocation Badge */}
              <div
                className={`text-center flex justify-center ${mobilescreen ? "w-full" : "col-span-2"}`}
              >
                <div>
                  {mobilescreen && (
                    <span className="text-[10px] text-slate-400 block uppercase font-sans font-bold mb-1">
                      Classroom:
                    </span>
                  )}
                  <span className="inline-flex items-center px-3 py-0.5 rounded-lg font-bold text-xs bg-[#F4F7FE] text-[#012063] border border-gray-200/50">
                    {classRoomName?.name || "Unassigned"}
                  </span>
                </div>
              </div>

              {/* Action Gateway Navigation Control */}
              <div
                className={`${mobilescreen ? "w-full flex justify-center mt-2" : "col-span-2 text-right pr-2"}`}
              >
                <button
                  type="button"
                  onClick={() => {
                    dispatch(selectStudent(item.id));
                    navigate(`/staff/child-activities/${item.id}`);
                  }}
                  className={`inline-flex items-center justify-center gap-2 px-4 py-2 bg-[#0096D1] hover:bg-[#0085ba] text-white text-xs font-bold rounded-xl shadow-xs transition-all active:scale-95 ${
                    mobilescreen ? "w-full py-3 rounded-2xl" : ""
                  }`}
                >
                  View Activities <FaArrowRight className="text-[10px]" />
                </button>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default RenderStudentList;
